import type { SellerInformation, StoreInformation } from '~/domain/PSF';
import type { GetSellersResponseDTO, GetStoreResponseDTO } from '~/dto/PSF';

export function sellerInfoDTOToSellerInfo(
  sellerDataDTO: GetSellersResponseDTO,
  document: string
): SellerInformation {
  return {
    name: sellerDataDTO.funcionario.nome,
    document,
  };
}

export function storeInfoDTToSellerInfo(
  storeDataDTO: GetStoreResponseDTO
): StoreInformation {
  const storeDto = storeDataDTO.listaFiliais[0]!;

  return {
    code: storeDto?.filCod,
    name: storeDto?.nome,
    address: storeDto?.endereco,
  };
}
